/* =========================================================
   __                 ____  _
  |   \  ___  __ __  |  _ || |  _ _   ___
  | |) |/ -_) \ V /  |  __|| | | | | / -_)
  |___/ \___|  \_/   |_|   |_| \_,_| \___| o o o   

========================================================= */

export const numberDisplay = (number, point = 2) => {
  const num = number === undefined ? 0 : number * 1;
  return num.toFixed(point).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const moneyDisplay = (number, point = 2, currency = "฿") => {
  const num = number === undefined ? 0 : number * 1;
  return `${currency} ${numberDisplay(num, point)}`;
};

export const dateDisplay = (date, style = 1) => {
  const dt = new Date(date);
  let result;

  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  let y = dt.getFullYear();

  d = d < 10 ? `0${d}` : d;
  m = m < 10 ? `0${m}` : m;
  y = style === 2 ? y - 2000 : y;

  if (y > 0) result = `${d}/${m}/${y}`;
  else result = "";

  return result;
};

export const dateTimeDisplay = (date = new Date(), style = 1) => {
  if (date === null) return "-";

  const dt = new Date(date);

  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  let y = dt.getFullYear();
  let h = dt.getHours();
  let i = dt.getMinutes();

  d = d < 10 ? `0${d}` : d;
  m = m < 10 ? `0${m}` : m;
  h = h < 10 ? `0${h}` : h;
  i = i < 10 ? `0${i}` : i;
  y = style === 2 ? y - 2000 : y;

  if (y > 0) return `${d}/${m}/${y} ${h}:${i}`;
  return "";
};

export const dateFormat = (date) => {
  const dt = new Date(date);

  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  const y = dt.getFullYear();

  d = d < 10 ? `0${d}` : d;
  m = m < 10 ? `0${m}` : m;

  return `${y}-${m}-${d}`;
};

export const dateTimeFormat = (date) => {
  const dt = new Date(date);

  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  const y = dt.getFullYear();
  let h = dt.getHours();
  let i = dt.getMinutes();
  let s = dt.getSeconds();

  d = d < 10 ? `0${d}` : d;
  m = m < 10 ? `0${m}` : m;
  h = h < 10 ? `0${h}` : h;
  i = i < 10 ? `0${i}` : i;
  s = s < 10 ? `0${s}` : s;

  return `${y}-${m}-${d} ${h}:${i}:${s}`;
};

export const timeFormat = (date) => {
  const dt = new Date(date);

  let h = dt.getHours();
  let i = dt.getMinutes();
  let s = dt.getSeconds();

  h = h < 10 ? `0${h}` : h;
  i = i < 10 ? `0${i}` : i;
  s = s < 10 ? `0${s}` : s;

  return `${h}:${i}`;
};

export const timeFormater = (str) => {
  let result;
  let h = 0;
  let m = 0;
  let hh = "";
  let mm = "";
  if (str.length > 5 || str.length < 4) {
    result = "";
  } else if (str.length === 4) {
    h = str.substr(0, 2) * 1;
    m = str.substr(2, 2) * 1;
  } else if (str.length === 5) {
    h = str.substr(0, 2) * 1;
    m = str.substr(3, 2) * 1;
  }
  if (h > 23 || m > 59) {
    result = "";
  } else {
    hh = h < 10 ? `0${h}` : h;
    mm = m < 10 ? `0${m}` : m;
    result = `${hh}:${mm}`;
  }

  return result;
};

export const lpadCode = (inp, size) => {
  const str = `${inp}`;
  return str.padStart(size, "0");
};

export const dateNow = () => {
  return dateFormat(new Date());
};

export const timeNow = () => {
  return timeFormat(new Date());
};

export const dateTimeNow = () => {
  return dateTimeFormat(new Date());
};

export const dateFirstMonth = () => {
  const dt = new Date();

  return dateFormat(new Date(dt.getFullYear(), dt.getMonth(), 1, 0, 0, 0, 0));
};

export const dateAdd = (day) => {
  const dt = new Date();
  dt.setDate(dt.getDate() + day);

  return dateFormat(new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0, 0));
};

export const verifyEmail = (value) => {
  const emailRex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
};

export const verifyLength = (value, length) => {
  if (value.length >= length) {
    return true;
  }
  return false;
};

export const exitApp = () => {
  // window.location.replace("/signin");
};
